import { Component, Injector, OnInit } from '@angular/core';
import { CommonService } from 'src/app-core/services/common.service';
import { CommonDataModel } from '../common-data-model';
import { DataStateChangeEvent, GridComponent } from '@progress/kendo-angular-grid';
import { AppComponentBase } from 'src/app/shared/app-component-base';
import * as moment from 'moment';
import { orderBy, SortDescriptor } from '@progress/kendo-data-query';
import { finalize } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-todays-appointment-print',
    templateUrl: './todays-appointment-print.component.html',
    styleUrls: ['./todays-appointment-print.component.scss']
})
export class TodaysAppointmentPrintComponent extends AppComponentBase implements OnInit {

    commonDataModel = new CommonDataModel();
    appointmentData = {
        employeeId: null,
        employeeName: 'All',
        date: new Date()
    };
    employees: any = [
        { employeeName: 'All', assignedTo: null }
    ];
    gridItems = this.commonDataModel.withoutPaginationReportsGridModel;
    multiple = false;
    allowUnsort = false;
    sort: SortDescriptor[] = [
        {
            field: 'displayId',
            dir: 'asc'
        }
    ];

    constructor(
        injector: Injector,
        private commonService: CommonService,
        private toastr: ToastrService
    ) {
        super(injector);
    }

    ngOnInit() {
        this.getEmployees();
        this.getAppointments();
    }

    getEmployees(): void {
        this.commonService.getEmployees(0).subscribe(response => {
            if (response.isSuccess) {
                const employeeList = response.data.filter(employee => employee.includeOnSchedule);
                this.employees = [...this.employees, ...employeeList];
            }
        });
    }

    getAppointments(): void {
        this.kendogridHelper.showLoadingIndicator();
        let filterQuery = `TodaysDate=${moment(this.appointmentData.date).format('YYYY-MM-DD')}`;
        filterQuery += this.appointmentData.employeeId ? `&EmployeeId=${this.appointmentData.employeeId}` : '';
        this.commonService.getAppointmentsReportGridRecords(filterQuery)
            .pipe(finalize(() => (this.kendogridHelper.hideLoadingIndicator()))).subscribe((response: any) => {
                if (response.isSuccess) {
                    this.gridItems = {
                        data: orderBy(response.data, this.sort),
                        total: response.data.length
                    };
                    this.kendogridHelper.hideLoadingIndicator();
                } else {
                    this.toastr.error(response.errors, 'Error!');
                }
            });

    }

    sortChange(sort: SortDescriptor[]): void {
        this.sort = sort;
        this.gridItems = {
            data: orderBy(this.gridItems.data, this.sort),
            total: this.gridItems.total
        };
    }

    onEmployeeChange(data: any) {
        if (data) {
            this.appointmentData.employeeId = data.assignedTo;
            this.appointmentData.employeeName = data.employeeName;
            this.getAppointments();
        }
    }

    onChangeDate(event: any) {
        this.getAppointments();
    }

    onPrint() {
        window.print();
        // const styles = `
        //     thead tr, thead tr th{
        //         background-color: red;
        //     }
        // `;
        // const divToPrint = document.getElementById('print-container');
        // const newWin = window.open('', 'Print-Window');
        // newWin.document.open();
        // newWin.document.write(
        //     `<html>
        //         <link rel="stylesheet" type="text/css" href="https://cdnjs.cloudflare.com/ajax/libs/twitter-bootstrap/4.3.1/css/bootstrap.min.css" media="print"/>
        //         <style>${styles}</style>
        //         <body onload="window.print()">${divToPrint.innerHTML}</body>
        //     </html>`);
        // newWin.document.close();
        // setTimeout(() => {
        //     newWin.close();
        // }, 10);
    }

}
